const useMakeContactOrderForm = (intitialData?: Client, initialType?: string) => {
  const { t } = useI18n();
  const { closeModal } = useModalStore();

  const { defineField, errors, handleSubmit, resetForm, setErrors } = useForm<MakeContractOrderForm>({
    initialValues: {
      nickname: intitialData?.nickname,
      name: intitialData?.name,
      phone: intitialData?.phone ? `+${intitialData.phone}` : null,
      type: initialType,
    },
    validationSchema: toTypedSchema(MAKE_CONTRACT_ORDER_SCHEMA),
  });

  const fields: MakeContractOrderFields = {
    nickname: defineField("nickname"),
    name: defineField("name"),
    phone: defineField("phone"),
    question: defineField("question"),
    type: defineField("type"),
  };

  const { loading, mutate, onDone, onError } = useMakeContactOrderDto();

  const submit = handleSubmit(async (formData) => {
    const data = copyData(formData);

    if (data.phone && data.phone.replaceAll(/\D/g, "").length <= 4) {
      setErrors({
        phone: localeValidation().invalidPhone,
      });

      return;
    }

    await mutate(data);
  });

  onDone(() => {
    const { openNotification } = useNotificationStore();

    resetForm();
    openNotification(t("notifications.messageSubmit"));
    closeModal();
  });

  onError(() => {
    setErrorsFields.graphql(setErrors, onError);
  });

  return {
    errors,
    fields,
    handleSubmit: submit,
    loading,
  };
};

export { useMakeContactOrderForm };
